import lessRequire from '../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';

lessRequire('modules/shared/filters/selected-filters.less');

const Main = props =>
	<div className="selected-filters">
		{props.appliedFilters.length
			? props.appliedFilters.map((f, i) =>
				<span
					className={cn({
						'selected-filter-item': true,
						highlight: f.shouldHighlight
					})}
					onClick={e => props.filterToggle(f.filterId)}
					onMouseEnter={() => props.filterToggleHighlight(f.filterId)}
					onMouseLeave={() => props.filterToggleHighlight(f.filterId)}
					key={i}
				>
					{props.intl(f.text)}
					<span
						className="delete"
						onClick={e => {
							e.stopPropagation();
							props.filterDeleteItem(f.filterId, f.suggestId, f.itemId, f.suggestAppliedItems);
						}}
					/>
				</span>
			)
			: null}
	</div>;

Main.propTypes = {
	appliedFilters: PropTypes.array,
	filterDeleteItem: PropTypes.func,
	filterToggle: PropTypes.func,
	filterToggleHighlight: PropTypes.func,
	toggleFilterFromHighlight: PropTypes.func,
	toggleFilterTabHighlight: PropTypes.func,
	deleteFilterItem: PropTypes.func,
	intl: PropTypes.func
};

export default Main;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/filters/selected-filters.js